<app-payment-gateway *ngIf="english"></app-payment-gateway>
<app-payment-gateway-hindi *ngIf="hindi"></app-payment-gateway-hindi>